import { EventGroup } from '@/types/projects.types';
import { Get } from '../helpers';

export function GetProjectGroups({
  channel,
  templatesOnly = false,
}: {
  channel: number;
  templatesOnly?: boolean;
}): Promise<EventGroup[]> {
  return Get({
    path: `/v3/admin/channel/${channel}/event-groups${templatesOnly ? '?templatesOnly=true' : ''}`,
  });
}
